module.exports = __webpack_public_path__ + "static/4-1feb1b993a7d307cb171cde55b0bddf9.png";